
interface IEnvironment {
    appName: string
    clientId: string
    baseUrl: string
    domain: string
    clientSecret: string
    toastDelay: number
    assets: string
}

export const environment: Readonly<IEnvironment> = {
    appName: 'بوهو',
    clientId: 'clientId',
    baseUrl: 'https://menu.bohostore.ir/',
    domain: 'https://menu.bohostore.ir/',
    clientSecret: 'clientSecret',
    toastDelay: 5000,
    assets: 'src/assets/'
}